import { ASSIGNEE_TYPES } from './dashboardBuilderConstants';

/**
 * Webpack/CRA no expone `import.meta.env`; Vite sí. Usamos NODE_ENV para no romper en runtime.
 */
export const isShareSearchMocksEnabled = () => process.env.NODE_ENV !== 'production';

/**
 * Departamentos mock (solo no-production) al final del listado — Figma 1:17748.
 * Solo departamentos; usuarios vienen del API.
 */
export const SHARE_SEARCH_DEV_MOCK_DEPARTMENTS = [
  {
    id: 'mock-share-dept-sales',
    name: 'Sales',
    userCount: 12,
    type: ASSIGNEE_TYPES.DEPARTMENT,
  },
  {
    id: 'mock-share-dept-service',
    name: 'Service',
    userCount: 8,
    type: ASSIGNEE_TYPES.DEPARTMENT,
  },
  {
    id: 'mock-share-dept-hr',
    name: 'Human Resources',
    userCount: 24,
    type: ASSIGNEE_TYPES.DEPARTMENT,
  },
  {
    id: 'mock-share-dept-rd',
    name: 'Research and Development',
    userCount: 6,
    type: ASSIGNEE_TYPES.DEPARTMENT,
  },
  {
    id: 'mock-share-dept-support',
    name: 'Customer Support',
    userCount: 15,
    type: ASSIGNEE_TYPES.DEPARTMENT,
  },
];

/**
 * Anexa mocks al final de `departments`, sin duplicar por `id`.
 */
export const mergeShareSearchMockDepartments = (departments = []) => {
  if (!isShareSearchMocksEnabled()) {
    return departments;
  }
  const seen = new Set(departments.map((d) => d.id).filter(Boolean));
  const merged = [...departments];
  SHARE_SEARCH_DEV_MOCK_DEPARTMENTS.forEach((mock) => {
    if (mock.id && !seen.has(mock.id)) {
      merged.push(mock);
      seen.add(mock.id);
    }
  });
  return merged;
};
